document.addEventListener('Searchanise.Loaded', function() {
(function($) {

$(document).on("Searchanise.DataRequestBefore", function (e, type, params) {
    if (type == "results") {
        params.ResultsDescriptionStrings = 10;
    }
});
$(document).on("Searchanise.DataRequestEnd", function (event, type, params, data) {
    var regex = /\[(.*?)\]]/gm;
    
    // Replace product description
    if (data.items) {
        for (var i = 0; i < data.items.length; i++) {
            var item_desc = data.items[i].description;
        
            if (item_desc) {
                data.items[i].description = item_desc.replace(regex, "");
            }
        }
    }
    
    // Replace page description
    if (data.pages) {
        for (var k = 0; k < data.pages.length; k++) {
            var page_desc = data.pages[k].description;
        
            if (page_desc) {
                data.pages[k].description = page_desc.replace(regex, "");
            }
        }
    }
    
    // Replace category description
    if (data.categories) {
        for (var j = 0; j < data.categories.length; j++) {
            var cat_desc = data.categories[j].description;
        
            if (cat_desc) {
                data.categories[j].description = cat_desc.replace(regex, "");
            }
        }
    }
});

})(window.Searchanise.$);
});